import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import UploadedAccountStatementsView
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/BalanceSheet/UploadedAccountStatementsComponents/Layout/UploadedAccountStatementsView';
import UploadedAccountStatementDetailView
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/BalanceSheet/UploadedAccountStatementsComponents/Layout/UploadedAccountStatementDetailView';
import PropTypes from 'prop-types';

const UploadedAccountStatementsLayout = ({ setCollection }) => {
  const { resource } = useMetaLayoutContext();
  const [uploadedAccountStatementDetailResource, setUploadedAccountStatementDetailResource] = React.useState(null);
  const [uploadedAccountStatementDetailIndex, setUploadedAccountStatementDetailIndex] = React.useState(0);


  if (uploadedAccountStatementDetailResource) {
    return (<UploadedAccountStatementDetailView
      setUploadedAccountStatementDetailResource={setUploadedAccountStatementDetailResource}
      setUploadedAccountStatementDetailIndex={setUploadedAccountStatementDetailIndex}
      uploadedAccountStatementDetailResource={uploadedAccountStatementDetailResource}
      uploadedAccountStatementDetailIndex={uploadedAccountStatementDetailIndex}
      uploadedAccountStatementsResource={resource}
      setUploadedAccountStatementsCollection={setCollection}
    />);
  }

  return (<UploadedAccountStatementsView
    setUploadedAccountStatementDetailResource={setUploadedAccountStatementDetailResource}
    setUploadedAccountStatementDetailIndex={setUploadedAccountStatementDetailIndex}
    uploadedAccountStatementsResource={resource}
  />);
};

UploadedAccountStatementsLayout.propTypes = {
  setCollection: PropTypes.func.isRequired,
};

UploadedAccountStatementsLayout.defaultProps = {
};


export default UploadedAccountStatementsLayout;
